export default "__VITE_ASSET__DWFze5UD__"